import React from "react";

export default function Portfolio() {
    return (
        <div id="portfolio" className="section">
            <div className="container mx-auto max-w-[1200px] px-3 pt-3 pb-20">
                <div className="flex flex-col lg:flex-row justify-between items-center mb-[50px]">
                    <div className="order-2 lg:order-1 mt-5 text-center lg:text-left flex flex-col items-center lg:items-start">
                        <h4 className="text-gradient font-primary max-w-[700px]" data-aos="fade-right"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">
                            Menerima Pekerjaan
                        </h4>
                        <div className="text-gradient font-primary max-w-[700px]" data-aos="fade-right"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">
                            saya bisa mengerjakan apa saja yang anda tawarkan ke saya karena saya adalah seorang programmer
                        </div>
                    </div>
                    <div className="order-1 lg:order-2 text-center">
                        <h2 className="text-gradient font-primary max-w-[700px] mx-auto text-[50px]"> 04 </h2>
                        <div className="text-gradient font-semibold" data-aos="fade-right"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">Memperlengkapi pekerjaan yang diminta</div>
                    </div>
                </div>
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 text-center" data-aos="fade-right"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">
                    {["images/foto.png", "images/nabo.png", "images/sekolah.png", "images/sertifikasi.png"].map((src, index) => (
                        <div key={index} className="w-full">
                            <div className="relative bg-white h-auto max-w-[150px] mx-auto flex justify-center items-center rounded-lg overflow-hidden p-2 group transition-all duration-500">
                                <img src={src} alt="" className="w-full h-auto object-cover group-hover:scale-95 transition-transform duration-300 ease-out" />
                                <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-green-500 opacity-0 scale-0 group-hover:opacity-100 group-hover:scale-100 transition-all duration-300 flex items-center justify-center">
                                    <div className="text-center text-white p-4">
                                        <h4 className="text-xl font-bold mb-2" data-aos="fade-right"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">Ini adalah hasil Project yang sudah saya buat </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Tambahkan link media sosial di sini */}
                <div className="mt-10 flex justify-center space-x-6">
                    <a href="https://www.facebook.com/Dar.Amenda.16" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">
                        Facebook
                    </a>
                    <a href="https://www.youtube.com/@darsonamenda" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:text-red-800">
                        YouTube
                    </a>
                    <a href="https://www.instagram.com/dariusamenda" target="_blank" rel="noopener noreferrer" className="text-pink-600 hover:text-pink-800">
                        Instagram
                    </a>
                    <a href="https://www.twitter.com/dariusamenda" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-600">
                        Twitter
                    </a>
                </div>
            </div>
        </div>
    );
}
